import React from 'react';
import { DraggableProvided } from 'react-beautiful-dnd';
import { ExerciseOrSuperset, RoutineExercise } from '../../../types/Fisiofit/routine';
import { isSuperset } from '../../../utils/supersetUtils';

// Función para obtener el nombre a mostrar de un ejercicio o superserie
const getExerciseDisplayName = (exerciseOrSuperset: ExerciseOrSuperset): string => {
  return (exerciseOrSuperset as RoutineExercise).name || 'Ejercicio';
};

interface ExerciseDragCloneProps {
  exercise: ExerciseOrSuperset;
  provided: DraggableProvided;
  exerciseListWidth: number;
}

export const ExerciseDragClone = ({ exercise, provided, exerciseListWidth }: ExerciseDragCloneProps) => {
  // Si es un superset, mostrar la estructura completa
  if (isSuperset(exercise)) {
    const superset = exercise as RoutineExercise[];
    const style = {
      ...provided.draggableProps.style,
      width: exerciseListWidth,
    } as React.CSSProperties;

    return (
      <div
        {...provided.draggableProps}
        {...provided.dragHandleProps}
        ref={provided.innerRef}
        style={style}
        className='exercise-item superset-item is-dragging'
      >
        <div className='superset-content'>
          <div className='superset-drag-handle'>
            <i className='pi pi-bars'></i>
          </div>
          <div className='superset-exercises-container'>
            {superset.map((supersetExercise, supersetIndex) => (
              <div
                key={supersetIndex}
                className={`superset-exercise-row ${supersetIndex === 0 ? 'first-exercise' : 'second-exercise'}`}
              >
                <div className='exercise-header'>
                  <div className='exercise-info'>
                    <span className='exercise-name'>{supersetExercise.name || 'Ejercicio sin nombre'}</span>
                  </div>
                </div>
                {supersetIndex === 0 && (
                  <div className='superset-break-button'>
                    <i className='pi pi-times'></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  // Si es un ejercicio individual, usar el renderizado original
  const style = {
    ...provided.draggableProps.style,
    width: exerciseListWidth,
  } as React.CSSProperties;
  return (
    <div
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      ref={provided.innerRef}
      style={style}
      className='exercise-item is-dragging'
    >
      <div className='drag-handle-exercise'>
        <i className='pi pi-bars'></i>
      </div>
      <span className='exercise-name'>{getExerciseDisplayName(exercise)}</span>
    </div>
  );
};
